import { render, staticRenderFns } from "./PrismicBlog.vue?vue&type=template&id=415966cc&"
import script from "./PrismicBlog.vue?vue&type=script&lang=js&"
export * from "./PrismicBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports